import React from 'react'
import { Card, Col, Flex, Row } from 'antd'
import { ModuleTopHeading, NotificationTable } from '../../components';

const Notificationpage = () => {

    
    return (
        <>
            <Card className='shadow-d radius-12'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Flex vertical gap={20}>
                            <ModuleTopHeading level={4} name='Notifcations'/>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <NotificationTable/>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Notificationpage }
